module.exports = __webpack_public_path__ + "img/empty_layout.abdd6237.svg";